export default "__VITE_ASSET__Dg$dbV8___"